import { render, staticRenderFns } from "./choose_goods_types.vue?vue&type=template&id=bf85afe0&scoped=true&"
import script from "./choose_goods_types.vue?vue&type=script&lang=js&"
export * from "./choose_goods_types.vue?vue&type=script&lang=js&"
import style0 from "./choose_goods_types.vue?vue&type=style&index=0&id=bf85afe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf85afe0",
  null
  
)

export default component.exports